var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "registerForm",
      staticClass: "forgot-pwd-form",
      attrs: {
        model: _vm.registerForm,
        "label-width": "110px",
        "label-position": "right",
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "账号", prop: "email" } },
        [
          _c("el-input", {
            attrs: { size: "small", placeholder: "请输入邮箱" },
            model: {
              value: _vm.registerForm.email,
              callback: function ($$v) {
                _vm.$set(_vm.registerForm, "email", $$v)
              },
              expression: "registerForm.email",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "验证码", prop: "code" } },
        [
          _c("el-input", {
            attrs: { size: "small", placeholder: "请输入验证码" },
            model: {
              value: _vm.registerForm.code,
              callback: function ($$v) {
                _vm.$set(_vm.registerForm, "code", $$v)
              },
              expression: "registerForm.code",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "obtain-code",
              attrs: { disabled: _vm.countdown > 0 },
              on: { click: _vm.handleCode },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.countdown > 0
                      ? _vm.countdown + "秒后重新获取"
                      : "获取验证码"
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: { label: "登录密码", prop: "password" },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _c("span", [_vm._v("登录密码")]),
                  _vm._v(" \n      "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "密码必须同时包含大小写英文和数字，长度:8-64",
                        placement: "top",
                      },
                    },
                    [_c("i", { staticClass: "iconfont icon-wenhao" })]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("input", {
            staticStyle: { display: "none" },
            attrs: { type: "password", autocomplete: "new-password" },
          }),
          _c(
            "el-input",
            {
              attrs: {
                type: _vm.passwordType,
                size: "small",
                placeholder: "请设置登录密码",
              },
              model: {
                value: _vm.registerForm.password,
                callback: function ($$v) {
                  _vm.$set(_vm.registerForm, "password", $$v)
                },
                expression: "registerForm.password",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-view el-input__icon",
                attrs: { slot: "suffix" },
                on: { click: _vm.showPassword },
                slot: "suffix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "确认登录密码", prop: "confirmPassword" } },
        [
          _c(
            "el-input",
            {
              attrs: {
                type: _vm.confirmPasswordType,
                size: "small",
                placeholder: "请再次输入设置登录密码",
              },
              model: {
                value: _vm.registerForm.confirmPassword,
                callback: function ($$v) {
                  _vm.$set(_vm.registerForm, "confirmPassword", $$v)
                },
                expression: "registerForm.confirmPassword",
              },
            },
            [
              _c("i", {
                staticClass: "el-icon-view el-input__icon",
                attrs: { slot: "suffix" },
                on: { click: _vm.showConfirmPassword },
                slot: "suffix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "您的姓名", prop: "name" } },
        [
          _c("el-input", {
            attrs: {
              size: "small",
              placeholder: "请输入姓名",
              maxlength: "20",
            },
            model: {
              value: _vm.registerForm.name,
              callback: function ($$v) {
                _vm.$set(_vm.registerForm, "name", $$v)
              },
              expression: "registerForm.name",
            },
          }),
        ],
        1
      ),
      _vm.website.validateCode
        ? _c(
            "el-form-item",
            { attrs: { prop: "code" } },
            [
              _c("Verify", {
                ref: "verify",
                attrs: {
                  mode: "pop",
                  "captcha-type": "blockPuzzle",
                  "img-size": { width: "330px", height: "155px" },
                },
                on: { success: _vm.verifySuccess },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-button",
        {
          staticClass: "login-submit",
          attrs: { type: "primary", size: "small" },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.handleRegister.apply(null, arguments)
            },
          },
        },
        [_vm._v("注册\n  ")]
      ),
      _c("div", { staticClass: "login-tips" }, [
        _vm._v("已有账号？"),
        _c(
          "span",
          { staticClass: "jump-login", on: { click: _vm.jumpLogin } },
          [_vm._v("去登录")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }